/**
 * 腾讯云COS配置
 */

export const COS_CONFIG = {
  // 腾讯云账号的 SecretId
  SecretId: 'AKIDOfGiwvfAQRDk25wa0B7oHVUDiyzkGXZP',
  
  // 腾讯云账号的 SecretKey
  SecretKey: 'g7JLrBH8k7F8mBLFuKVR7YmmX5SbVAds',
  
  // 存储桶所在地域
  Region: 'ap-guangzhou',
  
  // 存储桶名称
  Bucket: 'online-course-1396708969',
  
  // COS访问域名（可选，用于生成文件访问URL）
  Domain: `https://online-course-1396708969.cos.ap-guangzhou.myqcloud.com`,
  
  // 上传文件的默认路径前缀
  PathPrefix: {
    video: 'videos/',      // 视频文件
    image: 'images/',      // 图片文件
    document: 'documents/', // 文档文件
    other: 'files/'        // 其他文件
  }
}

/**
 * 根据文件类型获取上传路径前缀
 * @param {string} fileType - 文件类型
 * @returns {string} 路径前缀
 */
export function getPathPrefix(fileType) {
  const type = fileType.toLowerCase()
  
  if (type.includes('video') || ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv'].includes(type)) {
    return COS_CONFIG.PathPrefix.video
  }
  
  if (type.includes('image') || ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(type)) {
    return COS_CONFIG.PathPrefix.image
  }
  
  if (['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'].includes(type)) {
    return COS_CONFIG.PathPrefix.document
  }
  
  return COS_CONFIG.PathPrefix.other
}

/**
 * 生成唯一文件名
 * @param {string} originalName - 原始文件名
 * @returns {string} 新文件名
 */
export function generateUniqueFileName(originalName) {
  const timestamp = Date.now()
  const random = Math.random().toString(36).substring(2, 8)
  const ext = originalName.substring(originalName.lastIndexOf('.'))
  const nameWithoutExt = originalName.substring(0, originalName.lastIndexOf('.'))
  
  // 清理文件名中的特殊字符
  const cleanName = nameWithoutExt.replace(/[^\w\u4e00-\u9fa5-]/g, '_')
  
  return `${cleanName}_${timestamp}_${random}${ext}`
}

